module.exports = __webpack_public_path__ + "static/media/6.3c16d2ab.jpg";